import React, { useState, useEffect } from 'react';
// Import CSS & assets
import './TitleAndDescription.css';
import ico_rules_fill from '../../../../assets/ico/ico_rules_fill.svg';


const TitleAndDescription = ({ capacity, setCapacity }) => {

    // User
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));

    // isModel
    const [isModelChoice, setIsModelChoice] = useState(false);
    const [status_left, setStatus_left] = useState(0);
    const [status_width, setStatus_width] = useState(125);
    const handleIsModelChange = () => {
        setIsModelChoice(!isModelChoice);
    }
    const handleIsModelChange_true = () => {
        if (isModelChoice === false) {
            setIsModelChoice(true);
            setStatus_left(124);
            setStatus_width(92);
            handleIsModelChange_save(true);
        }
    }
    const handleIsModelChange_false = () => {
        if (isModelChoice === true) {
            setIsModelChoice(false);
            setStatus_left(0);
            setStatus_width(125);
            handleIsModelChange_save(false);
        }
    }
    const handleIsModelChange_save = (new_val) => {
        if (new_val !== capacity.isModel) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("isModel");
            toSaveData.autoSave = true;
            toSaveData.action = "Modification du type par";
            toSaveData.value = new_val ? "Modèle PLU" : "Etude capacitaire";
            setCapacity({ ...capacity, isModel: new_val, toSave: toSaveData });
        }
    }
    useEffect(() => {
        if (capacity?.isModel === true) {
            setIsModelChoice(true);
            setStatus_left(124);
            setStatus_width(92);
        }
    }, []);



    // Title
    const handleTitleChange = (e) => {
        // setCapacity({ ...capacity, title: e.target.value, toSave: { autoSave: false, action: "", value: "", keys: [] } });
    }
    const handleTitleBlur = (e) => {
        if (e.target.value !== capacity.title) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("title");
            toSaveData.autoSave = true;
            toSaveData.action = "Modification du titre par";
            toSaveData.value = e.target.value;
            setCapacity({ ...capacity, title: e.target.value, toSave: toSaveData });
        }
    }

    // Description
    const handleDescriptionChange = (e) => {
        // setCapacity({ ...capacity, description: e.target.value, toSave: { autoSave: false, action: "", value: "", keys: [] } });
    }
    const handleDescriptionBlur = (e) => {
        if (e.target.value !== capacity.description) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("description");
            toSaveData.autoSave = true;
            toSaveData.action = "Modification de la description par";
            toSaveData.value = e.target.value;
            setCapacity({ ...capacity, description: e.target.value, toSave: toSaveData });
        }
    }
    const descriptionResize = (element) => {
        element.rows = "1";
        element.rows = Math.ceil(element.scrollHeight / 20);
    }
    useEffect(() => {
        descriptionResize(document.getElementById("description"));
    }, [capacity]);

    // Share
    const handleShare = () => {
        var newShare = capacity?.share ? { ...capacity.share } : { isShared: false };
        newShare.isShared = !newShare.isShared;
        // Update and save
        var value = newShare.isShared === true ? "partagée" : "non partagée";
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("share");
        toSaveData.autoSave = true;
        toSaveData.action = "Changement des paramètres de partage de l'étude en ";
        toSaveData.value = value;
        setCapacity({ ...capacity, share: newShare, toSave: toSaveData });
    }

    return (
        <>
            <div className="app__sectiondata__widget">
                <div className="app__sectiondata_widget_title">Titre</div>
                <input className="app__sectiondata_widget_inputSingleLine app__sectiondata_widget_H1" type="text" id="title" name="title" defaultValue={capacity?.title} placeholder="Veuillez entrer un titre" required onChange={handleTitleChange} onBlur={handleTitleBlur}></input>
                <div className="app__sectiondata_widget_spacer"></div>
                <div className="app__sectiondata_widget_title">Description</div>
                <textarea className="app__sectiondata_widget_inputMultipleLine" id="description" name="description" defaultValue={capacity?.description} placeholder="Vous pouvez entrer une description de l'étude capacitaire" rows="1" onChange={handleDescriptionChange} onBlur={handleDescriptionBlur}></textarea>
                {(user?.result?.email.includes("@fractal-buildings.com") || user?.result?.email.includes("@proplab.fr")) &&
                    <>
                        <div className="app__sectiondata_widget_spacer_10"></div>
                        <div className="app__sectiondata_widget_title">Type</div>
                        {capacity?.step > 0 &&
                            <div className="app__ismodel_item_validated_container">
                                <div className="app__ismodel_item_validated">
                                    {capacity?.isModel === true &&
                                        <img src={ico_rules_fill} alt="" />
                                    }
                                    <div>{isModelChoice ? "Modèle PLU" : "Etude capacitaire"}</div>
                                </div>
                                {capacity?.isModel === true &&
                                    <div className="app__exportation_toogle_container">
                                        <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="switch_sharing_model" checked={capacity?.share?.isShared || false} onChange={() => { handleShare() }} /><label className="app__map_layer_checkbox_label" htmlFor="switch_sharing_model">Toggle</label></div>
                                        <div className="app__exportation_toogle_label">Publier ce Modèle PLU</div>
                                    </div>
                                }
                            </div>
                        }
                        {capacity?.step === 0 &&
                            <div className='app__ismodel_item_container'>
                                <div id='capa_ismodel_false' className={`app__ismodel_item ${isModelChoice ? "" : "app__ismodel_item_selected"}`} onClick={() => { handleIsModelChange_false() }}>Etude capacitaire</div>
                                <div id='capa_ismodel_true' className={`app__ismodel_item ${isModelChoice ? "app__ismodel_item_selected" : ""}`} onClick={() => { handleIsModelChange_true() }}>Modèle PLU</div>
                                <div className="app__buildings_info_status_indicator" style={{ left: status_left + 'px', width: status_width + 'px' }}></div>
                            </div>
                        }
                    </>
                }
            </div>
            <div className="app__sectiondata_widget_spacer"></div>
        </>
    );
};

export default TitleAndDescription;